// @ts-nocheck
/* eslint-disable */
import { makeEvent } from "~/lib/signals";
import { node, icon, separateWithElement } from "~/util/dom";
import { getRulesLink, getHelpLink } from "~/util/userweb";
import { CONFIG } from "~/config";
import createLinkButton from "./ui/linkbutton";
import GPXContent from '~/gpx/content';
import { _ } from "~/i18n";
import DistanceMeterContent from "~/distancemeter-content";
import UserMarksContent from "~/usermarks-content";
import Scene from "~/scene";
import Notifications from "~/util/notifications";
import createSDSIcon from "~/ui/icon";
import { FACEBOOK_24, INSTAGRAM_24, TWITTER_24, GOOGLE_PLAY_STORE_24, APPLE_STORE_24 } from "~/util/sds-compatible-icons";
import ReportHubDialog from "~/report/reportHubDialog";
import { APPLE_STORE_LINKS, GOOGLE_PLAY_STORE_LINKS } from "./util/constants";
import { store } from "./state/store";

(function() {
	/*
	to je kvuli pseudonaseptavaci, a naseptavaci aby nesli pres vychytavky
	*/
	const LAYOUT_MIN_HEIGHT = 450;
	const OVERLAY_LOADER_CLASS = "overlay-loader";

	/**
	 * @class Spravce hlavniho layoutu a sirky sloupce
	 * @signal width-change signal o zmene layoutu (sirka)
	 * @signal width-change-start signal o zacatku zmeny layoutu (sirky)
	 * @signal resize signal o zmene velikosti okna
	 */
	class Layout {
		_initLock: boolean;

		constructor() {
			this._defaultWidth = CONFIG.inFrame ? 0 : 1;
			this._width = -1; // aktualni sirka
			this._lastWidth = -1; // posledni sirka pred tim, nez se zmenila sirka na 0, abychom vedeli, na co to obnovit
			this._dom = {
				map: document.getElementById("map"),
				content: document.getElementById("layout-content"),
				scroll: node("div", { id: "layout-scroll" }),
				header: node("div", { id: "layout-header" }),
				body: node("div", { id: "layout-body" }),
				footer: node("div", { className: "layout__footer" }),
				logo: node("mapy-logo"),
				bar: node("div", { id: "layout-bar" }),
				blockMap: document.getElementById("block-map"),
				backButton: node("button", { innerHTML: _("back"), className: "back" }),
				overlayLoader: node("div", { className: "overlay-loader-el" }),
			}
			this._scrollHandlers = [];
			this._resizeHandlers = [];
			this._prevResolution = "";

			let loaderImg = new Image();
			loaderImg.src = "/img/loader.gif";
			loaderImg.crossOrigin = "anonymous";
			this._dom.overlayLoader.appendChild(loaderImg);
			this._dom.content.appendChild(this._dom.header);
			this._dom.content.appendChild(this._dom.scroll);
			this._dom.scroll.appendChild(this._dom.body);
			this._dom.scroll.appendChild(this._dom.footer);
			this._dom.content.appendChild(Notifications.container);
			this._initLock = false;

			this._buildHeader();
			this._buildFooter();

			if (Mapy.Util.isSmallResolution()) {
				this._defaultWidth = 0;
			}

			this._dom.blockMap.addEventListener("click", this, false);
			this._orientation = Mapy.Util.getOrientation();

			window?.addEventListener("resize", this, false);
			this._dom.scroll?.addEventListener("scroll", this, false);
			this._dom.content?.addEventListener("transitionend", this, false);
			this._dom.content?.addEventListener("webkitTransitionEnd", this, false);

			this._setMobilePromoLine();

			if (CONFIG.inFrame) {
				document.body.classList.add("frame");
				document.body.classList.remove("width-0");
			} else {
				Mapy.Util.getTweaks().then(function(tweaks) {
					tweaks.length && this._createTweak(tweaks[0]);
				}.bind(this), e => {});
			}
		}

		getScrollNode() {
			return this._dom.scroll;
		}

		_getHandlers(eventType) {
			let handlers;
			switch (eventType) {
				case "resize":
					handlers = this._resizeHandlers;
					break;
				case "scroll":
					handlers = this._scrollHandlers;
					break;
			}
			return handlers;
		}

		_dispatchHandlers(event) {
			const handlers = this._getHandlers(event.type);
			if (handlers instanceof Array) {
				for (var index = 0; index < handlers.length; index++) {
					var handler = handlers[index];
					handler(event);
				}
			}
		}

		subscribe(eventType, handler) {
			const handlers = this._getHandlers(eventType);
			if (handlers instanceof Array) {
				const index = handlers.indexOf(handler);
				if (index === -1) {
					handlers.push(handler);
				}
			}
		}

		unsubscribe(eventType, handler) {
			const handlers = this._getHandlers(eventType);
			if (handlers instanceof Array) {
				const index = handlers.indexOf(handler);
				if (index > -1) {
					handlers.splice(index, 1);
				}
			}
		}

		getState() {
			var state = {};
			if(Mapy.getComponent("imageUploader").isActive()) {
				return state;
			}
			var l = this._width > 0 ? 1 : 0;
			if (l != this._defaultWidth) {
				state.l = l;
			}
			return state;
		}

		initWidth() {
			const usp = new URLSearchParams(location.search);
			const lStrVal = usp.get("l");
			let lVal = Mapy.Util.isSmallResolution()
				? 0
				: 1;
			if (lStrVal) {
				const lNum = parseFloat(lStrVal);

				if (!isNaN(lNum)) {
					lVal = lNum;
				}
			// panorama
			} else if ((usp.has("pid") || usp.has("timeboard")) && !window.location.pathname.match(/^\/d\/.*$/u)) {
				lVal = 2;
			}

			this.setWidth(lVal, true);
			this._width = lVal;
			this._lastWidth = lVal;
			this._initLock = true;
		}

		setState(data) {
			if (Number(data.l) == -1) { data.l = 1; }
			var l = "l" in data ? Number(data.l) : this._defaultWidth;

			if (l > 0) {
				this.setWidth();
			} else {
				if (this._width <= 1) {
					this.setWidth(0);
				}
			}

			if (Mapy.getComponent("history").isFromHistory()) {
				this._initLock = false;
			}
		}

		getMap() {
			return this._dom.map;
		}

		getHeader() {
			return this._dom.header;
		}

		getBody() {
			return this._dom.body;
		}

		getWidth() {
			return this._width;
		}

		getBar() {
			return this._dom.bar;
		}

		getContent() {
			return this._dom.content;
		}

		setBottomPanel(node) {
			this.clearBottomPanel();
			this._dom.blockMap.appendChild(node);
		}

		clearBottomPanel() {
			Mapy.Util.clear(this._dom.blockMap);
		}

		setClassOnMapElement(className = "", add = true) {
			if (className) {
				this._dom.map.classList[add ? "add" : "remove"](className);
			}
		}

		setFullLogo(full = false) {
			this._dom.logo.mode = full ? "expanded" : "animated";
		}

		setWidth(width, instant = false) {
			if (width == this._width || this._initLock) { return; }
			if (width != 0 && width != undefined) { this._lastWidth = width; }
			if (width == undefined) { width = this._lastWidth; }
			/* pro spravne prekresleni mapy si pamatuji predesly layout a stavajici rozliseni */
			var oldWidth = this._width;
			this._prevResolution = Mapy.Util.isSmallResolution() ? "small" : "normal";

			/* dam o tom vsem vedet */
			makeEvent("width-change-start", this, { newWidth: width });

			var oldClass = "width-" + this._width;
			var newClass = "width-" + width;
			this._width = width;
			if (oldClass == newClass) { return; }

			var animate = false;
			var fromHistory = Mapy.getComponent("history") ? Mapy.getComponent("history").isFromHistory() : false;

			if (this._width != -1 && // nemenime na haluz hodnotu
				!instant && // nechceme zmenu bez animace
				!fromHistory && // neni to z historie
				oldWidth != -1 // neni to prvni nastaveni sirky
			) {
				animate = true;
			}

			if (animate) { this._dom.content.classList.add("transition"); }

			/* aktualizovat CSS tridu s sirkou */
			document.body.classList.remove(oldClass);
			document.body.classList.add(newClass);

			// pri prvni zmene, kterou vime, ze vola Scene, to nechceme udelat
			if (oldWidth !== -1) {
				this.checkBottomPanel();
			}

			if (animate) {
				/* pustit transition => samo */
				Scene.lock();
				var step = function() {
					Scene.syncPort();
					if (!this._dom.content.classList.contains("transition")) {
						Scene.unlock();
						return;
					}
					requestAnimationFrame(step);
				}.bind(this);
				step();
			} else {
				this._widthDone();
			}

			/* vynutim si prekreslenin mapy pri prechodu z layoutu bez mapy na layout s mapou */
			if(width != 2 && oldWidth == 2 && Mapy.Util.isSmallResolution()){
				Scene.redraw();
			}

			return this;
		}

		createLoader() {
			if (this._dom.scroll.classList.contains(OVERLAY_LOADER_CLASS)) return;

			this._dom.scroll.classList.add(OVERLAY_LOADER_CLASS);
			this._dom.scroll.appendChild(this._dom.overlayLoader);
		}

		removeLoader() {
			if (!this._dom.scroll.classList.contains(OVERLAY_LOADER_CLASS)) return;

			this._dom.scroll.classList.remove(OVERLAY_LOADER_CLASS);
			this._dom.overlayLoader.remove();
		}

		/* musim zjistit, zda aktivni komponenty jsou v defaultu nebo necim naplnene, kvuli malym rozlisenim*/
		_isFullActiveComponent() {
			var c = Mapy.active[0];

			if (c instanceof GPXContent || c instanceof Mapy.UserProfile) {
				return true;
			}

			var data = c ? c.getState() : {};

			var arr = ["q","rc","source","tid", "uc", "rm", "crc"];
			for(var i in data) {
				if(arr.indexOf(i) != -1) {
					return true;
				}
			}
			return false;
		}

		_widthDone() {
			this._dom.content.classList.remove("transition");

			if (this._width > 0) {
				if (Mapy.active[0] == Mapy.getComponent("search")) {
					Mapy.getComponent("search").focus();
				}
			}

			Scene.syncPort();
			/* dam o tom vsem vedet */
			makeEvent("width-change", this, { newWidth: this._width });
		}

		handleEvent(e) {
			switch (e.type) {
				case "scroll":
					this._dispatchHandlers(e);
				case "resize":
					this._dispatchHandlers(e);
					if (this._timeout) { clearTimeout(this._timeout); }
					this._timeout = setTimeout(this._resizeHandler.bind(this), 100);
				break;
				case "transitionend":
				case "webkitTransitionEnd":
					if (e.target == this._dom.content) { this._widthDone(); }
				break;

				case "click":
					if (e.target.classList.contains("layout__footer__mobilePromo")) {
						e.preventDefault();

						Mapy.getComponent("mobilepromo").activate();
						Mapy.getComponent("history").save();
					} else if (e.target.classList.contains("layout__footer__legend")) {
						e.preventDefault();

						var legend = Mapy.getComponent("legend");

						if (legend.isActive()) {
							legend.deactivate();
						}
						else {
							legend.activate();
						}

						Mapy.getComponent("history").save();
					} else if (e.currentTarget == this._dom.blockMap) {
						this._toggleWidth();
					} else if (e.target == this._dom.showMore) {
						Mapy.getComponent("tweaksList").activate();
						Mapy.getComponent("history").save();
					} else if (e.target.classList.contains("layout__footer__reportButton")) {
						const reportHubDialog = new ReportHubDialog();

						reportHubDialog.open();
					}
				break;
			}
		}

		/* kvuli mobilnimu zobrazeni */
		_toggleWidth() {
			if (this._width == 0) {
				this.setWidth(1, true);
			}
			else {
				this.setWidth(0, true);
			}
			Mapy.getComponent("history")?.save();
		}

		_resizeHandler() {
			Scene.syncPort();
			makeEvent("resize", this, {
				width: window.innerWidth,
				height: window.innerHeight
			});
			/* vynutim si prekreslenin mapy pri prechodu z maleho rozliseni na velke */
			if(this._prevResolution == "small" && !Mapy.Util.isSmallResolution()){
				Scene.redraw();
				this._dom.header.insertBefore(this._dom.bar, this._dom.header.firstChild);
			} else if (this._prevResolution == "normal" && Mapy.Util.isSmallResolution() && this.getWidth() === 0) {
				this.checkBottomPanel();
			}

			if (Scene.isM3dActive()) {
				// nastal resize - je potreba nad 3d vyvolat map-redraw
				Scene.makeEvent("map-redraw", {}, null);
			}

			this._prevResolution = Mapy.Util.isSmallResolution() ? "small" : "normal";
		}

		_buildFooter() {
			const isCzech = CONFIG.defaultLang === "cs";
			const linksData = {
				czech: {
					facebook: "https://www.facebook.com/Mapy.comcz",
					twitter: "https://x.com/mapy_comcz",
					instagram: "https://www.instagram.com/mapy_comcz",
				},
				com: {
					facebook: "https://www.facebook.com/mapy.com/",
					twitter: "https://x.com/mapy_com",
					instagram: "https://www.instagram.com/mapy_com",
				},
			};
			const linksSource = isCzech ? linksData.czech : linksData.com;
			const links = node("p", { className: "layout__footer__links" });
			const mobilePromoLink = node("a", { href: `/${CONFIG.defaultLang}/mobilepromo`, innerHTML: _("mobilePromo.link"), title: _("mobilePromo.linkTitle"), className: "layout__footer__mobilePromo" });
			const legendLink = node("a", { href: `/${CONFIG.defaultLang}/?lgnd=1`, innerHTML: _("legend.link"), className: "layout__footer__legend" });
			const bottomPart = node("div", { className: "layout__footer__bottomPart layout__footer__bottomPart--hidden" });
			const tweak = node("div", { className: "layout__footer__tweak" });
			const menu = node("div", { className: "layout__footer__topContainer" });
			const row1 = node("div", { className: "layout__footer__row" });
			const row2 = node("div", { className: "layout__footer__row" });
			const socials = node("div", { className: "layout__footer__socials" });
			const stores = node("div", { className: "layout__footer__stores" });
			const facebook = node("a", { target: "_blank", href: linksSource.facebook, title: "Facebook" });
			const twitter = node("a", { target: "_blank", href: linksSource.twitter, title: "X" });
			const instagram = node("a", { target: "_blank", href: linksSource.instagram, title: "Instagram" });
			const appleStore = node("a", { target: "_blank", href: APPLE_STORE_LINKS[CONFIG.defaultLang] || APPLE_STORE_LINKS.en, title: "Apple Store" });
			const googleStore = node("a", { target: "_blank", href: GOOGLE_PLAY_STORE_LINKS[CONFIG.defaultLang] || GOOGLE_PLAY_STORE_LINKS.en, title: "Google Play Store" });
			const reportButton = node("button", { innerHTML: _("layout.report"), className: "layout__footer__reportButton" });
			const peronalizationLink = node("a", { href: `https://ucet.seznam.cz/consents${CONFIG.defaultLang === "cs" ? "" : `?lang=${CONFIG.defaultLang}`}`, target: "_blank", innerHTML: _("layout.personalization")});
			const logoLink = node("a", { href: "/" });

			reportButton.addEventListener("click", this, false);
			mobilePromoLink.addEventListener("click", this, false);
			legendLink.addEventListener("click", this, false);
			peronalizationLink.addEventListener("click", event => {
				const { user } = store.getState().user;

				if (user.state != "green") {
					event.preventDefault();

					scmp.open();
				}
			}, false);

			links.append(...separateWithElement([
				node("a", { href: getHelpLink(), target: "_blank", innerHTML: _("layout.help")}),
				legendLink,
				... ["cs", "en", "sk", "pl"].indexOf(CONFIG.defaultLang) > -1
					? [ mobilePromoLink ]
					: [],
				node("a", { href: `https://www.seznam.cz/reklama/${["cs", "sk"].indexOf(CONFIG.defaultLang) > -1 ? `cz` : `en`}/obsahovy-web/sluzba-firmy`, target: "_blank", innerHTML: _("layout.comm")}),
				node("a", { href: getRulesLink(), target: "_blank", innerHTML: _("layout.rulesandlicence")}),
				reportButton,
				peronalizationLink,
				node("a", { href: `https://developer.mapy.cz/${["cs", "sk"].indexOf(CONFIG.defaultLang) > -1 ? `` : `en/`}`, target: "_blank", innerHTML: _("layout.developers")}),
			], node("span", { innerHTML: " &bull; " })));

			row1.append(links);

			facebook.appendChild(createSDSIcon({ symbol: FACEBOOK_24 }));
			twitter.appendChild(createSDSIcon({ symbol: TWITTER_24 }));
			instagram.appendChild(createSDSIcon({ symbol: INSTAGRAM_24 }));
			socials.append(facebook, twitter, instagram);

			appleStore.append(createSDSIcon({ symbol: APPLE_STORE_24 }));
			googleStore.append(createSDSIcon({ symbol: GOOGLE_PLAY_STORE_24 }));
			stores.append(appleStore, googleStore);

			row2.append(...separateWithElement([socials, stores], node("span", { innerHTML: " &bull; " })));

			logoLink.append(this._dom.logo);
			this._dom.tweak = tweak;
			menu.appendChild(logoLink);
			menu.appendChild(Mapy.getComponent("languageControl").getContainer());
			bottomPart.appendChild(tweak);
			this._dom.footer.append(bottomPart, menu, row1, row2);
			this._dom.bottomPart = bottomPart;
		}

		_buildHeader() {
			this._dom.header.appendChild(this._dom.bar);
		}

		_isMobilePromoLine() {
			if(document.getElementById("appPromoCont").offsetHeight) {
				return true;
			}
			return false;
		}

		_setMobilePromoLine() {
			if(this._isMobilePromoLine()) {
				document.body.classList.add("mobilePromoLine");
			}
		}

		checkBottomPanel() {
			/* prohazovani stateswitche pro mala rozliseni */
			var node = this._dom.bar;

			if (Mapy.Util.isSmallResolution() && this._width != 0 && this._dom.bar.parentNode !== this._dom.header) {
				this._dom.header.insertBefore(this._dom.bar, this._dom.header.firstChild);
			} else if (Mapy.Util.isSmallResolution()) {
				var isFull = this._isFullActiveComponent();
				if(!isFull) {
					this.setBottomPanel(node);
				} else {
					var c = Mapy.active[0];
					if((c instanceof UserMarksContent) || (c instanceof DistanceMeterContent) || (c instanceof Mapy.Route3) || (c instanceof GPXContent)) {
						c.setBottomPanel();
					}
				}
			}
		}

		_createTweak(firstTweak) {
			const showMore = createLinkButton({
				innerHTML: _("search.bottomPart.allTweaks"),
			});

			this._dom.showMore = showMore;
			showMore.addEventListener("click", this, false);

			this._dom.tweak.insertAdjacentHTML("afterbegin", firstTweak.content.rendered);
			this._dom.tweak.firstElementChild.insertAdjacentHTML("afterbegin", `<span class="date">${Mapy.Util.dateFormat(new Date(firstTweak.date), "d. m. yyyy")}</span>`);
			this._dom.tweak.appendChild(showMore);
		}

		showBottomPart(state) {
			state = state ? "remove" : "add";

			var className = "layout__footer__bottomPart--hidden";
			var contains = this._dom.bottomPart.classList.contains(className) ? "add" : "remove";

			if (state != contains) {
				this._dom.bottomPart.classList[state](className);
			}
		}
	}

	Mapy.Layout = Layout;

	Mapy.Layout.LAYOUT_MIN_HEIGHT = LAYOUT_MIN_HEIGHT;
}());
